import { render, staticRenderFns } from "./restart.vue?vue&type=template&id=36af5f34&scoped=true&"
import script from "./restart.vue?vue&type=script&lang=js&"
export * from "./restart.vue?vue&type=script&lang=js&"
import style0 from "./restart.vue?vue&type=style&index=0&id=36af5f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af5f34",
  null
  
)

export default component.exports